export const POLICY_URL = 'https://msk.rt.ru/legal';
export const TODAY = 5;
